import { render, staticRenderFns } from "./LanguagePicker.vue?vue&type=template&id=18ac4a75&scoped=true&"
import script from "./LanguagePicker.ts?vue&type=script&lang=ts&"
export * from "./LanguagePicker.ts?vue&type=script&lang=ts&"
import style0 from "./LanguagePicker.scss?vue&type=style&index=0&id=18ac4a75&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ac4a75",
  null
  
)

export default component.exports